<template>
  <div id="print-report">
    <component v-if="component"
               :is="component"
               :form="body"
               :header="header"
               :board="board"
               :projectId="projectId"
               :boardId="boardId"
               :postId="postId"
    />
    <span v-if="err">{{err}}</span>
  </div>
</template>

<script>
import {req} from "vuelidate/lib/validators/common";
import HttpRequest from "@/util/HttpRequest";

export default {
  name: "Print",
  computed: {
    verified() {
      return this.$route.query.verified;
    },
    boardId() {
      return this.$route.query.boardId;
    },
    postId() {
      return this.$route.query.postId;
    }
  },
  mounted() {
    // const postId = 2793;
    // const boardId = 976;
    // this.$store.dispatch("board/LOAD_POST", {
    //   boardId,
    //   postId,
    // }).then((response) => {
    //   this.component = () => import(`@/views/boards/single-page/${boardId}/Print.vue`);
    //   const contents = JSON.parse(response.post_content);
    //   this.body = contents.body;
    //   this.header = contents.header;
    //   this.print('@media print {@page { size: a3 portrait; }}');
    // });


    const query = this.$route.query;
    HttpRequest.get('/api/v1/qr-post/detail', {
      params: query,
    }).then(response => {
      this.component = () => import(`@/views/boards/single-page/${this.boardId}/Print.vue`);
      this.projectId = response.project_id;
      this.boardId = response.board_id;
      this.postId = response.id;
      const contents = JSON.parse(response.post_content);
      this.body = contents.body;
      this.header = contents.header;
      this.print('@media print {@page { size: a3 portrait; }}');
    }).catch(err => {
      this.err = err;
    })
  },
  data() {
    return {
      component: null,
      body: null,
      header: null,
      board: null,

      projectId: 0,
      boardId: 0,
      postId: 0,

      err: undefined,
    };
  },
  methods: {
    onImageLoaded(img) {
      return new Promise((resolve, reject) => {
        if (img.complete) {
          // 이미지가 이미 로드된 경우
          resolve();
        } else {
          // 로드 이벤트 리스너 등록
          img.addEventListener('load', resolve);
          img.addEventListener('error', reject);
        }
      });
    },

    print(css) {

      setTimeout(() => {

        const g_oBeforeBody = document.getElementById("print-report").innerHTML;

        // 프린트를 보이는 그대로 나오기위한 셋팅
        window.onbeforeprint = function () {
          document.body.style.backgroundColor = "#fff";
          document.body.innerHTML = "";
          document.body.innerHTML += g_oBeforeBody;
        };

        const head = document.head || document.getElementsByTagName("head")[0],
          style = document.createElement("style");

        style.type = "text/css";
        style.media = "print";

        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }
        head.appendChild(style);

        // QR코드 이미지가 로드될때까지 대기
        const imgElement = document.querySelector('img[alt="Scan me!"]');
        if (imgElement) {
          this.onImageLoaded(imgElement).then(() => {
            window.pageFullyLoaded = true;
          }).catch(err => {
            this.err = err;
          });
        } else {
          window.pageFullyLoaded = true;
        }

      }, 500);
    }
  }
}
</script>

<style scoped>

</style>
